import React from "react";
import { FaCss3Alt, FaHtml5, FaReact } from "react-icons/fa";
import { IoLogoJavascript, IoLogoWordpress } from "react-icons/io5";
import { SiNextdotjs } from "react-icons/si";


function SkillSet1() {
  
  return (
    <>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <FaHtml5 />
        </p>
        {/* <p>HTML5 - 90%</p> */}
        <p>HTML5</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <FaCss3Alt />
        </p>
        {/* <p>CSS3 - 80%</p> */}
        <p>CSS3</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <IoLogoJavascript />
        </p>
        {/* <p>JavaScript - 75%</p> */}
        <p>JavaScript</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <FaReact />
        </p>
        {/* <p>React - 80%</p> */}
        <p>React JS</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <SiNextdotjs />
        </p>
        {/* <p>Next Js - 80%</p> */}
        <p>Next JS</p>
      </div>
      <div className="skills-set col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <p>
          <IoLogoWordpress />
        </p>
        {/* <p>WordPress - 90%</p> */}
        <p>WordPress</p>
      </div>
    </>
  );
}

export default SkillSet1;
